import { gql, useMutation } from '@apollo/client';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

interface TData {
  removeEncoder: boolean;
}

interface TVariables {
  location: string;
}

interface Args {
  location: string;
}

const MUTATION = gql`
  mutation RemoveEncoder($location: String!) {
    removeEncoder(location: $location)
  }
`;

export const useRemoveEncoder = (): [
  (args: Args) => Promise<boolean | undefined>,
  MutationResult<boolean, 'success'>
] => {
  const [mutate, { data, loading, error, called }] = useMutation<TData, TVariables>(MUTATION);

  return [
    useCallback(async (args: Args) => {
      try {
        if (!args.location){ 
            return undefined;
        }

        const response = await mutate({ variables: { location: args.location } });

        return response.data?.removeEncoder;
      } catch {
        return undefined;
      }
    }, [mutate]),
    {
      called,
      loading,
      success: data?.removeEncoder ?? false,
      error
    }
  ];
};